/* global __DEV__ */
import React from 'react';
import 'rxjs-compat';

//WMCE-455: Reduced muster initialization -- changed path for ebanking
import EBanking from './ebanking';
import App from './components/app';

import './assets/postcss/ebanking.css';

function EBankingDev() {
  return (
    <EBanking>
      <App />
    </EBanking>
  );
}

export default EBankingDev;
